import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { scrantonConfig } from "./data";

export default function ScrantonPage() {
  return <CityPageTemplate config={scrantonConfig} />;
}